import type { ReactNode } from 'react';

export const symbol_watch_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m438-452 120-120q9-9 21-9t21 9q9 9 9 21.5t-9 21.5L459-388q-9 9-21.5 9t-21.5-9l-56-57q-9-9-9-21t9-21q9-9 21-9t21 9l36 35Zm-27-368h138-138Zm0 680h138-138Zm1 60q-20 0-36.5-12T354-124l-25-91q-5-16-14.5-30.5T289-274q-42-37-65.5-90T200-480q0-62 23-115.5t65-90.5q16-14 26-29t15-30l25-91q5-20 21.5-32t36.5-12h136q20 0 36.5 12t21.5 32l25 91q5 16 15 30.5t26 28.5q42 36 65 89.5T760-480q0 62-23.5 115T671-274q-16 14-25.5 28.5T631-215l-25 91q-5 20-21.5 32T548-80H412Zm224-244q64-64 64-156t-64-156q-64-64-156-64t-156 64q-64 64-64 156t64 156q64 64 156 64t156-64ZM393-744q23-7 44.5-10.5T480-758q21 0 42.5 3.5T567-744l-18-76H411l-18 76Zm18 604h138l18-76q-23 6-44.5 9.5T480-203q-21 0-42.5-3.5T393-216l18 76Z"
		/>
	</svg>
);
